import React from 'react';
import './Home.css';

// Import required components and constants
import { Button } from '../../../components';
import { home } from '../../../constants';

// Import Swiper core and required modules
import { Navigation, Autoplay } from 'swiper/modules';

// Import Swiper React components
import { Swiper, SwiperSlide } from 'swiper/react';

import { FaWifi } from 'react-icons/fa';

// Import Swiper styles
import 'swiper/css';
import 'swiper/css/navigation';



const Home = () => {

  return (
    <section className='home'>

      {/* Home Slider Container */}
      <div className='home-slider'>

        <Swiper
          // Install Swiper modules
          modules={[Navigation, Autoplay]}
          loop={true} // Enables infinite looping
          autoplay={{ delay: 5000, disableOnInteraction: true }} // Auto-slide settings
          navigation // Enables navigation buttons
          pagination={{ clickable: true }} // Enable pagination dots
        >
          {home.map((item) => {
            return (
              <SwiperSlide className='home-item' key={item.id}>

                {/* Background image for each slide */}
                <img src={item.image} alt="Home-Pic" />

                {/* Content overlay */}
                <div className="content">
                  <div className="text">

                    <h5><FaWifi />{item.subtitle}<FaWifi /></h5> {/* Subtitle with Icons */}

                    {/* Main title with optional highlighted span inside curly braces */}
                    <h3>
                      {
                        item.title.includes('{') ? (
                          <>
                            {item.title.split('{')[0]}               {/* Text before the span */}
                            <span>{item.title.split('{')[1].split('}')[0]}</span> {/* Highlighted text */}
                            {item.title.split('}')[1]}               {/* Text after the span */}
                          </>
                        ) : item.title                              // Plain title if no special format
                      }
                    </h3>

                    {/* Pricing section */}
                    <div className='price-box'>
                      <div className='price'>{item.price}</div> {/* Price value */}
                      <p>/ {item.priceUnit}</p> {/* Price Unit */}
                    </div>

                    <Button link={item.buttonLink} title={item.buttonText} /> {/* CTA Button */}
                  </div>
                </div>

              </SwiperSlide>
            )
            })
          }
        </Swiper>
      </div>
    </section>
  )
}

export default Home;